import { Injectable } from '@angular/core';
import {throwError } from 'rxjs';
import { catchError, tap, map, timeout } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Platform } from '@ionic/angular';
import { PtyNotificationService } from './pty-notification.service';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class PtyWsService {
	_headers: HttpHeaders;
	_httpURL: string = '';
	_methods: object = {

		/* new methods for app initialization */
		username_exist: 'username-exist',
		email_exist: 'email-exist',
		get_language_team: 'private/get-language-team',
		get_app_languages: 'get-app-languages',
		add_phrase: 'add-phrase',
		get_app_translation_by_user: 'private/get-app-translation-by-user',
		init_login_page: 'init-login-page',
		token_expired: 'token-expired',
		get_current_user: 'get-current-user',

		apiVersion: 'api-version',
		login: 'login',
		'login-switch-user': 'login-switch-user',
		login_status: 'login-status',
		logout: 'logout',
		register: 'register',
		confirm_email: 'confirm-email',
		login_social: 'register-social',
		user_recover_pass: 'user-recover-pass',
		user_recover_pass_change: 'user-recover-pass-change',
		verify_token_and_api: 'verify-token-and-api',

		set_user_token_notifications: 'set-user-token-notifications',
		remove_user_token_notifications: 'remove-user-token-notifications',

		/* TO DO: update all instances of languages to use get_app_languages */
		languages: 'languages',

		/* TO DO: update all instances of get_default_language to use get_language_team*/
		get_default_language: 'get-default-language',

		/* TO DO: remove get_default_language_code */
		get_default_language_code: 'get-default-language-code',

		/* TO DO: refactor language component which calls these 2 methods to use new get_app_translation_by_user */
		get_app_translation: 'get-app-translation',
		get_country_translation: 'get-country-translation',

		all_languages: 'all-languages',
		set_app_langauge: 'set-app-langauge',
		get_translation_for_contact: 'get-translation-for-contact',

		user_application: 'user-application',
		user_application_save: 'user-application-save',
		
		user_notifications: 'user-notifications',
		user_group_notifications: 'user-group-notifications',
		user_notification_update: 'user-notification-update',
		load_preferences: 'user-load-preferences',
		save_preferences: 'user-save-preferences',
		change_password: 'user-change-password',
		calendar: 'user-calendar',
		calendar_save: 'user-calendar-save',
		disciples: 'user-disciples',
		seeker_assign: 'seeker-assign',
		seeker_assign_init: 'seeker-assign-init',
		seeker_reassign: 'seeker-reassign',
		seeker_profile: 'seeker-profile',
		'seeker-profile-popups': 'seeker-profile-popups',
		seeker_save_profile: 'seeker-save-profile',
		seeker_timeline: 'seeker-timeline',
		seeker_take_conversation: 'seeker-take-conversation',
		seeker_switch_channel: 'seeker-switch-channel',
		seeker_disciple: 'seeker-disciple',
		conversation: 'seeker-conversation',
		conversations: 'seeker-conversations',
		seeker_conversations_regular_user: 'seeker-conversations-regular-user',
		conversation_prefs: 'seeker-conversation-prefs',
		conversation_templates: 'seeker-conversation-templates',
		conversation_messages: 'seeker-conversation-messages',
		groups: 'groups',
		groups_pined: 'groups_pined',
		group_messages: 'group-messages',
		group_send_message: 'group-send-message',
		send_message: 'send-message',
		trainings: 'trainings',
		training_quiz_result: 'training-quiz-result',
		training_quiz_start: 'training-quiz-start',
		training_quiz_finish: 'training-quiz-finish',
		training_quiz_save_answer: 'training-quiz-save-answer',
		load_suggestions: 'suggestions',
		save_suggestion_rate: 'suggestion-rate',
		send_corporate_message: 'send-corporate-message',
		admin_om_conversations: 'admin_om_conversations',
		admin_om_messages: 'admin_om_messages',
		admin_om_send_message: 'admin_om_send_message',
		app_share_invite: 'app_share_invite',
		file_upload: 'file-upload',
		get_files: 'get-files',
		save_files: 'save-files',
		delete_file: 'delete-file',
		collect_testimony: 'seeker-testimony-request',
		send_testimony_link: 'send_testimony_link',
		seeker_profile_control: 'seeker-profile-controls',
		user_profile_control: 'user-profile-controls',
		get_countries: 'get-countries',
		user_notes_mark_read: 'user-notes-mark-read',
		hide_group_message: 'hide-group-message',
		get_my_seekers: 'get-my-seekers',
		merge_seekers: 'merge_seekers',
		get_my_leaders: 'my-leaders',
		check_leader_conversation: 'check-leader-conversation',
		collect_testimony_followup: 'collect-testimony-followup',
		discipleship_followup: 'discipleship-followup',
		update_testimony_followup: 'update-testimony-followup',
		prepare_attachment_url: 'prepare-attachment-url',
		get_conversations_categories: 'get-conversations-categories',
		get_my_conversations_categories: 'get-my-conversations-categories',
		get_categorized_conversations: 'get-categorized-conversations',
		subscribe_conversations_categories: 'subscribe-conversations-categories',
		subscribe_conversations_categories_default: 'subscribe-conversations-categories-default',
		mark_read_group_chat: 'mark-read-group-chat',
		user_templates: 'user-templates',
		user_links: 'user-links',
		user_links_save: 'user-links-save',
		submit_story: 'submit-story',
		get_bibles: 'get-bibles',
		store_bible_version: 'store-bible-version',
		get_my_bible_version: 'get-my-bible-version',
		check_duplicate_document: 'check-duplicate-document',
		get_archived_contacts: 'get-archived-contacts',
		'get-all-archived-contacts': 'get-all-archived-contacts',
		unmark_first_login: 'private/unmark-first-login',
		connect_to_church: 'connect-to-church',
		get_user_testimonies: 'get-user-testimonies',
		insert_notifications: 'insert-notifications',
		shareVerseAsMessage: 'shareVerseAsMessage',
		AddToBibleShare: 'add-bible-history',
		getBibbleHistory: 'get-bible-history',
		set_Vacation: 'setvacation',
		partialApplicationEmail: 'partial-Application-Email',
		markAsRead: 'update-unread-conversation',
		get_unread_conversation: 'get-unread-conversation',
		get_testimony: 'seeker-testimony',
		drafts: 'update-drafts',
		disciples_update: 'user-disciples-update',
		editdocxtitle: 'edit-file',
		searchconversation: 'search-message',
		search_archived_contacts: 'search-archived-contacts',
		close_conversation: 'close-conversation',
		admin_om_unread_count: 'admin_om_unread_count',
		seeker_conversations_search: 'seeker-conversations-search',
		'get-reference-data': 'get-reference-data',
		'update-reference-data': 'update-reference-data',
		update_conversation_ispinned:'update-conversation-ispinned',
		pinned_conversation:'seeker-conversations-is-pinned',
		training_ai_chat: 'private/training-conversation-ai',
		'combined-tab-seekers': 'combined-tab-seekers',
		'combined-seeker-request': 'combined-seeker-request',
		'combined-seeker-profile': 'combined-seeker-profile',
		'user-badge-count': 'user-badge-count',
		'user-auto-assign-contact': 'user-auto-assign-contact',
		'copilot-demo': 'copilot-demo',
	};
	_deviceId: string = 'browser';
	_deviceType: string = '';
	_deviceInfo: any = null;
	_userData: any = null;
	_sessionId: number = Math.floor(Math.random() * 10000000000000000);

	constructor(private httpClient: HttpClient, private platform: Platform, private notif: PtyNotificationService) {
		this._headers = new HttpHeaders();
		// 'Access-Control-Allow-Origin,Access-Control-Allow-Methods,Access-Control-Allow-Headers,Content-Type,Authorization'
		this._headers = this._headers.append('Authorization', 'Basic ' + environment.WS_AUTHORIZATION);
		this._headers = this._headers.append('Content-Type', 'application/json');
		this._headers = this._headers.append('Access-Control-Allow-Origin', '*');
		this._headers = this._headers.append('Access-Control-Allow-Methods', 'POST,OPTIONS,GET');
		this._headers = this._headers.append('Access-Control-Allow-Headers', 'Access-Control-Allow-Origin');
		this._headers = this._headers.append('X-Path-Session-Id', ('' + this._sessionId));

		this._httpURL = environment.WS_END_POINT;

	}

	setUserInfo(userData: any) {
		// NOTE: The only userData currently needed here is token & uuid
		this._userData = userData;
	}

	setDeviceInfo(deviceInfo: any) {
		this._deviceInfo = deviceInfo;
		if (typeof this._deviceInfo.registration !== 'undefined') {
			this._deviceId = this._deviceInfo.registration.registrationId;
			this._deviceType = this._deviceInfo.registration.registrationType;
		}
	}

	clearUserInfo() {
		this._userData = null;
	}

	invokeURL(url: string, data: any, timeoutDuration =  null) {
		if (this._deviceInfo == null) {
			this._deviceInfo = this.notif.deviceInfo;
		}

		let postData = { ...data, ...this._userData };
		let ok: string;

		let resource = this.httpClient.post(this._httpURL + this._methods[url], postData, { headers: this._headers });

		/*
		 NOTE: This code is split because the original code (the else section) was not firing the add phrase API,
		   however, the code under the add_phrase section was double-executing, no idea why.
		   So the current code state is a hackish compromise to keep stuff working
		 */
		if (url === 'add_phrase') {
			const subscription = resource.subscribe(
				(event) => {
					subscription.unsubscribe();
					if (event == null) {
						console.error('Response came null from server', event);
						return { error: 1, message: 'internal_error' };
					} else {
						return event;
					}
				},
				err => this.handleError(err)
			);
			return resource;
		} else {
			if (timeoutDuration) {
				resource = resource.pipe(timeout(timeoutDuration))
			}
			// Note: this commented out section of code was, I believe, causing the add-phrase API to never execute
			return resource.pipe(
				map((event) => {
					if (event == null) {
						console.error('Response came null from server', event);
						return { error: 1, message: 'internal_error' };
					} else {
						return event;
					}
				}),
				catchError(err => {
					console.log(err);
					return this.handleError(err);
				})
			);
		}
	}

	invokePutURL(url: string, data: any) {
		if (this._deviceInfo == null) {
			this._deviceInfo = this.notif.deviceInfo;
		}

		let postData = { ...data, ...this._userData };
		let ok: string;

		return this.httpClient.put(this._httpURL + this._methods[url], postData, { headers: this._headers }).pipe(
			map((event) => {
				if (event == null) {
					console.error('Response came null from server', event);
					return { error: 1, message: 'internal_error' };
				} else {
					return event;
				}
			}),
			catchError(this.handleError)
		);
	}

	invokegetURL(url: string, data: any) {
		if (this._deviceInfo == null) {
			this._deviceInfo = this.notif.deviceInfo;
		}

		let postData = { ...data, ...this._userData };
		let ok: string;
		return this.httpClient
			.get(this._httpURL + this._methods[url], {
				params: {
					email: this._userData.email,
					token: this._userData.token,
				},
			})
			.pipe(
				map((event) => {
					if (event == null) {
						console.error('Response came null from server', event);
						return { error: 1, message: 'internal_error' };
					} else {
						return event;
					}
				}),
				catchError(this.handleError)
			);
	}

	private handleError(error: HttpErrorResponse) {
		console.log('error to handle', error);
		if (error.error instanceof ErrorEvent) {
			// A client-side or network error occurred. Handle it accordingly.
			console.error('An error occurred:', error.error.message);
		} else {
			// The backend returned an unsuccessful response code.
			// The response body may contain clues as to what went wrong,
			console.error(`Backend returned code ${error.status}, ` + `body was: ${JSON.stringify(error)}`);
		}
		// return an observable with a user-facing error message
		return throwError('Something bad happened; please try again later.');
	}
}
